import React, { useMemo } from 'react'
import { Form, Select } from 'antd'
import { useSelector } from 'react-redux'

import { inputRequired } from '../../util/forms.utils'
import { selectUsers } from '../../store/users/users.selector'

const AssignCandidateForm = ({ form, onFinish }) => {
  const users = useSelector(selectUsers)
  const usersFound = useMemo(() => users.filter(user => user.investigator), [users])

  return (
    <Form
      form={form}
      onFinish={onFinish}
    >
      <Form.Item
        name='userId'
        rules={[inputRequired]}
      >
        <Select
          placeholder='Seleccionar un usuario'
          optionFilterProp='children'
        >
          {
            usersFound.map(user => {
              return (
                <Select.Option key={`user_${user.id}`} value={user.id}><b>{user.name}</b> ({user.email})</Select.Option>
              )
            })
          }
        </Select>
      </Form.Item>
    </Form>
  )
}

export default AssignCandidateForm
